import PageHeader from '../layout/PageHeader'
import Accessible from '@mui/icons-material/Accessible'
import PageContainer from '../layout/PageContainer'

const Home = () => {
  return (
    <>
      <PageHeader
        icon={<Accessible fontSize="large" />}
        title="Piaskownica"
        subtitle="To nasze bagno"
      />
      <PageContainer></PageContainer>
    </>
  )
}

export default Home
